import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  showRefuseModal() {
    document.getElementById('refuseModal').classList.remove('hidden')
    // Focus on the textarea
    const textarea = document.querySelector('#refuseModal textarea')
    if (textarea) {
      setTimeout(() => textarea.focus(), 100)
    }
  }

  hideRefuseModal() {
    document.getElementById('refuseModal').classList.add('hidden')
  }
}
